import React from 'react';
import { SectionHeading } from './SectionHeading';
export function DifferenceSection() {
  return <section aria-labelledby="diferencia" className="bg-cream" data-id="element-61" data-mp="1b2h34cf0sw49">
      <div className="mx-auto max-w-6xl px-5 py-20 lg:py-24" data-id="element-62" data-mp="1b4bqdxdrl0bi">
        <div className="grid gap-14 lg:grid-cols-[1.15fr_0.85fr] lg:items-center lg:gap-20" data-id="element-63" data-mp="1p2jhhoo4d7er">
          <div data-id="element-64" data-mp="1k1vtlbv6t6or">
            <SectionHeading align="left" title={<>
                  De estudiar inglés sin rumbo a tener{' '}
                  <span className="italic text-coral" data-id="element-66" data-mp="1y0bx6txr6h2o">todo organizado</span> frente a tus ojos.
                </>} data-id="element-65" data-mp="1k12m28oemd5k" />
            <div className="mt-7 max-w-reading space-y-5 text-lg leading-relaxed text-muted" data-id="element-67" data-mp="1tz0ez9h7ky4i">
              <p style={{
              fontStyle: "italic",
              textDecorationLine: "none"
            }} data-id="element-68" data-mp="27u2jbs6eqff7">
                Deja de saltar de video en video.  Ahora tienes una ruta visual de aprendizaje, desde A1 hasta C2, con estructuras, vocabulario y expresiones avanzadas.
              </p>
              
            </div>
          </div>

          <div className="divide-y divide-line border-t border-line lg:border-l lg:border-t-0 lg:pl-12" data-id="element-69" data-mp="2frnnzp1qdtob">
            {[{
            value: '+300',
            label: 'Mapas mentales visuales'
          }, {
            value: '6',
            label: 'Niveles de inglés'
          }, {
            value: 'A1 → C2',
            label: 'Una progresión completa'
          }].map(item => <div key={item.label} className="grid grid-cols-[7rem_1fr] items-baseline gap-x-5 py-6 first:pt-8 sm:grid-cols-[9rem_1fr] lg:first:pt-0" data-id="element-70" data-mp="2tpc6wrc8mqqq">
                <span className="whitespace-nowrap font-display text-3xl font-black leading-none text-coral sm:text-4xl" data-id="element-71" data-mp="33otddazbd8nr">
                  {item.value}
                </span>
                <span className="text-sm font-semibold uppercase leading-snug tracking-[0.12em] text-ink" data-id="element-72" data-mp="3chohg1d1oyby">{item.label}</span>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}